module.exports = {"id":"211990","name":"Odisseas Vlachodimos","rating":"73","photo":"./data/images/photos/3/211990.png","club":{"name":"Panathinaïkos","logo":"./data/images/clubs/Panathinaikos.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OdisseasVlachodimos0.json
// module id = 3248
// module chunks = 0